<template>
  <div class="answer_subjects_container">
    <div class="subjects_box">
      <div class="detail_box">
        <div class="title">
          <span>答题内容：</span><span v-text="detail.title"></span>
          <span class="answer_status ongoing" v-if="detail.status == 2">（进行中）</span>
          <span class="answer_status over" v-else-if="detail.status == 3">（已结束）</span>
          <span class="answer_status not_start" v-else>（未开始）</span>
        </div>
        <div class="answer_comp">
          <span class="part_num">
            <Icon iconClass="users" />已有<span v-text="detail.participateNumber" v-if="detail.status == 2||detail.status == 3"></span><span v-else>0</span>人参加
          </span>
        </div>
        <div class="time">
          <Icon iconClass="time" /><span v-text="time"></span>
        </div>
      </div>
      <ul class="questions" v-if="itemList.length>0">
        <li class="question_title clearfix">
          <div class="title">{{getItemTypeLabel(itemList[cur].type)}}</div>
          <div class="num"><span class="cur" v-text="cur+1"></span>/<span v-text="itemList.length"></span></div>
        </li>
        <li class="question_item" v-for="(item,index) in itemList" :key="index">
          <div class="title" v-if="cur==index">
            {{ ( index + 1 ) }}、{{ item.type == 3 ? item.fillingTitle : item.title }}
            <label class="required" v-if="item.isAnswer">*</label>
            <label class="item_type">【{{getItemTypeLabel(item.type)}}】</label>
            <label class="score" v-if="detail.isGrade">{{ item.score }}分</label>
          </div>
          <!-- 单选 -->
          <div class="question_body" v-if="cur==index && item.type==1">
            <div class="radio_list radio_img_list clearfix" v-if="item.supportPicture==1">
              <div :class="{radio:true,checked:opt.checked}" v-for="( opt, n ) in item.options" :key="n" @click="onRadioClick(item.options,opt);">
                <div class="radio_img_box">
                  <div class="img">
                    <img :src="opt.dataPath" alt="" v-if="opt.dataPath && opt.dataPath.length>0">
                    <img :src="require('@/assets/images/default_pic_4_3.png')" alt="" v-else />
                  </div>
                </div>
                <input type="radio" :name="'radioGorup' + item.subjectId" :checked="opt.checked">
                <div class="info">
                  <span class="title_text">{{opt.itemTitle}}</span>
                </div>
              </div>
            </div>
            <div class="radio_list" v-else>
              <div :class="{radio:true,checked:opt.checked}" v-for="( opt, n ) in item.options" :key="n" @click="onRadioClick(item.options,opt);">
                <input type="radio" :name="'radioGorup' + item.subjectId" :checked="opt.checked">
                <label>
                  <span class="num_text">{{getSelectLabel(n)}}</span><span class="title_text">{{opt.itemTitle}}</span>
                </label>
              </div>
            </div>
          </div>
          <!-- 多选 -->
          <div class="question_body" v-if="cur==index && item.type==2">
            <div class="check_list check_img_list clearfix" v-if="item.supportPicture==1">
              <div :class="{checkbox:true,checked:opt.checked}" v-for="(opt,n) in item.options" :key="n" @click="onCheckClick(opt);">
                <div class="check_img_box">
                  <div class="img">
                    <img :src="opt.dataPath" alt="" v-if="opt.dataPath && opt.dataPath.length>0">
                    <img :src="require('@/assets/images/default_pic_4_3.png')" alt="" v-else />
                  </div>
                </div>
                <input type="checkbox" :name="'checkboxGorup' + item.subjectId" :checked="opt.checked">
                <div class="info">
                  <span class="title_text">{{opt.itemTitle}}</span>
                </div>
              </div>
            </div>
            <div class="check_list" v-else>
              <div :class="{checkbox:true,checked:opt.checked}" v-for="(opt,n) in item.options" :key="n" @click="onCheckClick(opt);">
                <input type="checkbox" :name="'checkboxGorup' + item.subjectId" :checked="opt.checked">
                <label>
                  <span class="num_text">{{getSelectLabel(n)}}</span><span class="title_text">{{opt.itemTitle}}</span>
                </label>
              </div>
            </div>
          </div>
          <!-- 填空 -->
          <div class="question_body" v-if="cur==index && item.type==3">
            <div class="fill" v-html="getBlockHTML( item.title, item.subjectId )"></div>
          </div>
          <!-- 问答 -->
          <div class="question_body" v-if="cur==index && item.type==4">
            <textarea :placeholder="getPlaceholder( item )" v-model="item.value"></textarea>
          </div>
          <!-- 判断 -->
          <div class="question_body" v-if="cur==index && item.type==5">
            <div class="judge_list">
              <div :class="{judge:true,split_line:true,checked:item.value=='1'}" @click="item.value='1'">
                <input type="radio" :name="'radioGorup' + item.subjectId" :checked="item.value=='1'">
                <label><span class="title_text">对</span></label>
              </div>
              <div :class="{judge:true,checked:item.value=='0'}" @click="item.value='0'">
                <input type="radio" :name="'radioGorup' + item.subjectId" :checked="item.value=='0'">
                <label><span class="title_text">错</span></label>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="operate_box">
      <span class="operate_btn" @click="prev" v-if="cur>0">上一题</span>
      <span class="operate_btn" @click="next" v-if="cur<(itemList.length-1)">下一题</span>
      <span class="operate_btn" @click="onAnswerSubmit" v-if="detail.status==2 && cur==(itemList.length-1)">提 交</span>
    </div>
  </div>
</template>
<script>
import { getSelectLabel } from "@/utils";
import { mapState } from "vuex";
import answerApi from "@/api/apis/answer.js";
export default {
  name: "AnswerSubjects",
  props: {
    params: {
      type: Object,
      default: {
        contentType: 10,
        id: null,
        type: 1, // 类型 0-学习 1-答题
      },
    },
    detail: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      cur: 0,
      itemList: [], // 题库
    };
  },
  computed: {
    ...mapState("app", ["userInfo"]),
    /* 答题时间 */
    time() {
      let time = this.detail.startDate + " " + this.detail.startTime;
      time += " - ";
      time += this.detail.endDate + " " + this.detail.endTime;
      return time;
    },
  },
  methods: {
    showWarning(msg) {
      this.$toast({
        message: msg,
        position: "center",
      });
    },
    /* 题目类型 */
    getItemTypeLabel(type) {
      if (1 == type) return "单选题";
      if (2 == type) return "多选题";
      if (3 == type) return "填空题";
      if (4 == type) return "问答题";
      if (5 == type) return "判断题";
    },
    /* 单选/多选编号，A、B、C、D */
    getSelectLabel(n) {
      return getSelectLabel(n);
    },
    /* 问答题 placeholder */
    getPlaceholder(item) {
      var min = item.minWordcount;
      var max = item.maxWordcount;
      if (min == 0 && max == 0) return "";
      var str = "请输入";
      if (min > 0) str += "不少于" + min + "个字";
      if (max > 0)
        str += (str == "请输入" ? "" : "，") + max + "个字以内的内容";
      return str;
    },
    /* 填空 */
    getBlockHTML(str, subjectId) {
      return str.replace(
        /<BLOCK><\/BLOCK>/g,
        '<input type="text" name="fill' + subjectId + '" class="fill_input">'
      );
    },
    /* 单选框组，选择操作 */
    onRadioClick(options, option) {
      if (option.checked == false) {
        option.checked = true;
        for (var i = 0; i < options.length; i++) {
          if (option.itemId != options[i].itemId) {
            options[i].checked = false;
          }
        }
      }
    },
    /* 多选框组，选择操作 */
    onCheckClick(option) {
      if (option.checked) {
        option.checked = false;
      } else {
        option.checked = true;
      }
    },
    /* 获取题目列表 */
    getQuestionnaireSubjects() {
      var _this = this;
      var params = {
        memberId: _this.userInfo.id,
        questionnaireId: _this.params.id,
      };
      answerApi
        .getQuestionnaireSubjects(params)
        .then((res) => {
          let list = res.data.list;
          list.forEach(function (item, i) {
            if (item.type == 1 || item.type == 2) {
              item.options.forEach(function (option, j) {
                option.checked = false;
              });
            } else if (item.type == 5) {
              item.value = "1";
            }
          });
          _this.itemList = list;
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 上一题 */
    prev() {
      if (this.cur > 0) {
        this.cur--;
      }
    },
    /* 下一题 */
    next() {
      if (this.cur < this.itemList.length - 1) {
        this.cur++;
      }
    },
    /* 提交答题 */
    onAnswerSubmit() {
      var _this = this;

      if (!_this.userInfo) {
        _this.$router.push("/login");
        return;
      }
      
      var params = {
        memberId: _this.userInfo.id,
        questionnaireId: _this.params.id,
        subjectValue: [],
      };
      for (var i = 0; i < _this.itemList.length; i++) {
        let item = _this.itemList[i];
        var answer = {
          subtopic_id: item.subjectId,
          value: "",
        };
        // 单选
        if (1 == item.type) {
          item.options.forEach(function (opt, j) {
            if (opt.checked) {
              answer.value = opt.itemId;
            }
          });
          if (item.isAnswer && !answer.value) {
            _this.showWarning("题目" + (i + 1) + "是必答题，请作答后再提交。");
            return;
          }
        }
        // 多选
        else if (2 == item.type) {
          var ids = [];
          item.options.forEach(function (opt, j) {
            if (opt.checked) {
              ids.push(opt.itemId);
            }
          });
          answer.value = ids.toString();
          if (item.isAnswer && !answer.value) {
            _this.showWarning("题目" + (i + 1) + "是必答题，请作答后再提交。");
            return;
          }
        }
        // 填空
        else if (3 == item.type) {
          var list = [];
          var fillDoms = document.getElementsByName("fill" + item.subjectId);
          fillDoms.forEach(function (dom, index) {
            var str = dom.value.replace(/^\s+|\s+$/g, "");
            if (item.isAnswer && "" == str) {
              _this.showWarning(
                "题目" + (i + 1) + "是必答题，请填写所有空格。"
              );
              return;
            }
            list.push({ answer: str });
          });
          answer.value = list;
        }
        // 问答
        else if (4 == item.type) {
          answer.value = item.value;
          if (item.isAnswer) {
            answer.value = answer.value.replace(/^\s+|\s+$/g, "");
            /** 判断字数限制 **/
            var min = item.minWordcount;
            var max = item.maxWordcount;
            if (min > 0 && answer.value.length < min) {
              _this.showWarning(
                "题目" + (i + 1) + "，您输入的字不足" + min + "个。"
              );
              return;
            } else if (max > 0 && answer.value.length > max) {
              _this.showWarning(
                "题目" + (i + 1) + "，您输入的字超过了" + max + "个。"
              );
              return;
            }
          }
        }
        // 判断
        else if (5 == item.type) {
          answer.value = item.value;
          if (item.isAnswer && !answer.value) {
            _this.showWarning("题目" + (i + 1) + "是必答题，请作答后再提交。");
            return;
          }
        }
        params.subjectValue.push(answer);
      }

      params.subjectValue = JSON.stringify(params.subjectValue);

      answerApi
        .addQuestionAnswer(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.$emit("submited", res.data);
          } else if (res.suc == 0 && res.message == '您已提交过一份答卷') {
            _this.$dialog
              .alert({
                message: res.message || res.text,
              })
              .then(() => {
                _this.$emit("alreadySubmited");
              });
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
  },
  created() {
    this.getQuestionnaireSubjects(); // 获取题目列表
  },
};
</script>
<style scoped lang="scss">
.answer_subjects_container {
  width: 100%;
  height: calc(100% - 50px);
  padding: 0;
  overflow-x: hidden;
  overflow-y: auto;
  .subjects_box {
    .detail_box {
      padding: 10px 15px;
      background: #fff;
      .title {
        padding: 5px 0 10px;
        line-height: 24px;
        color: #333;
        font-size: 18px;
        font-weight: bold;
        .answer_status {
          color: #eb7a0b;
          &.ongoing {
            color: #00a250;
          }
          &.over {
            color: #e93931;
          }
        }
      }
      .answer_comp {
        line-height: 20px;
        padding: 0 0 10px;
        .part_num {
          color: #a6a6a6;
          font-size: 12px;
          .tj-svg-icon {
            margin-right: 5px;
            font-size: 18px;
          }
        }
      }
      .time {
        line-height: 24px;
        color: #666;
        font-size: 16px;
        .tj-svg-icon {
          color: #a6a6a6;
          margin-right: 5px;
          font-size: 18px;
        }
      }
    }
    .questions {
      margin: 15px;
      padding-bottom: 15px;
      background: #fff;
      box-shadow: 4px 3px 6px #ccc, -4px 0px 6px #ccc;
      .question_title {
        line-height: 30px;
        border-bottom: 1px solid #ececec;
        padding: 15px 15px 5px;
        margin-bottom: 10px;
        .title {
          position: relative;
          float: left;
          padding-left: 10px;
          color: #333;
          font-size: 18px;
          font-weight: bold;
          &::before {
            position: absolute;
            left: 0;
            top: 7px;
            display: block;
            width: 4px;
            height: 16px;
            background-color: #397ef5;
            content: "";
          }
        }
        .num {
          float: right;
          font-size: 14px;
          .cur {
            color: #333;
            font-size: 18px;
            font-weight: bold;
          }
        }
      }
      .question_item {
        padding-left: 15px;
        padding-right: 15px;
        .title {
          line-height: 24px;
          text-align: justify;
          color: #333;
          font-weight: bold;
          .required {
            color: red;
          }
          .score {
            float: right;
            color: red;
          }
        }
        .question_body {
          margin-top: 8px;
          .radio_list {
            margin-bottom: 10px;
            .radio {
              line-height: 24px;
              padding: 8px 10px;
              border: 2px solid #ececec;
              border-radius: 5px;
              margin-bottom: 15px;
              &.checked {
                border-color: #397ef5;
              }
              label {
                .num_text {
                  margin-left: 5px;
                }
                .title_text {
                  margin-left: 5px;
                }
              }
            }
            /deep/img {
              max-width: 100%;
            }
            &.radio_img_list {
              .radio {
                float: left;
                position: relative;
                width: calc(50% - 7.5px);
                padding: 0;
                border-width: 1px;
                border-radius: 8px;
                overflow: hidden;
                &:nth-child(2n + 1) {
                  margin-right: 15px;
                }
                .radio_img_box {
                  position: relative;
                  width: 100%;
                  height: 0;
                  padding-bottom: 75%;
                  background-color: #fff;
                  .img {
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    z-index: 1;
                    img {
                      display: block;
                      width: 100%;
                      height: 100%;
                    }
                  }
                }
                input[type="radio"] {
                  display: none;
                }
                &::after {
                  position: absolute;
                  right: 0;
                  top: -1px;
                  display: block;
                  width: 30px;
                  height: 30px;
                  z-index: 2;
                  background-image: url(~@/assets/images/icon_unselect.png);
                  background-repeat: no-repeat;
                  background-position: center center;
                  background-size: contain;
                  content: "";
                }
                &.checked {
                  &::after {
                    background-image: url(~@/assets/images/icon_select.png);
                  }
                }
              }
              .info {
                padding: 5px 12px 5px;
                line-height: 21px;
                .title_text {
                  color: #333;
                  font-size: 14px;
                }
              }
            }
          }
          .check_list {
            .checkbox {
              line-height: 24px;
              padding: 8px 10px;
              border: 2px solid #ececec;
              border-radius: 5px;
              margin-bottom: 15px;
              &.checked {
                border-color: #397ef5;
              }
              label {
                .num_text {
                  margin-left: 5px;
                }
                .title_text {
                  margin-left: 5px;
                }
              }
            }
            /deep/img {
              max-width: 100%;
            }
            &.check_img_list {
              .checkbox {
                float: left;
                position: relative;
                width: calc(50% - 7.5px);
                padding: 0;
                border-width: 1px;
                border-radius: 8px;
                overflow: hidden;
                &:nth-child(2n + 1) {
                  margin-right: 15px;
                }
                .check_img_box {
                  position: relative;
                  width: 100%;
                  height: 0;
                  padding-bottom: 75%;
                  background-color: #fff;
                  .img {
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    z-index: 1;
                    img {
                      display: block;
                      width: 100%;
                      height: 100%;
                    }
                  }
                }
                input[type="checkbox"] {
                  display: none;
                }
                &::after {
                  position: absolute;
                  right: 0;
                  top: -1px;
                  display: block;
                  width: 30px;
                  height: 30px;
                  z-index: 2;
                  background-image: url(~@/assets/images/icon_unselect.png);
                  background-repeat: no-repeat;
                  background-position: center center;
                  background-size: contain;
                  content: "";
                }
                &.checked {
                  &::after {
                    background-image: url(~@/assets/images/icon_select.png);
                  }
                }
              }
              .info {
                padding: 5px 12px 5px;
                line-height: 21px;
                .title_text {
                  color: #333;
                  font-size: 14px;
                }
              }
            }
          }
          textarea {
            width: 100%;
            height: 112px;
            line-height: 24px;
            padding: 10px;
            background: #f6f6f6;
            border: 1px solid #eee;
            border-radius: 5px;
            resize: none;
          }
          .fill {
            padding: 5px 0;
            line-height: 24px;
            /deep/.fill_input {
              border: none;
              outline: none;
              border-bottom: 1px solid #000;
            }
          }
          .judge_list {
            border: 1px solid #ececec;
            border-radius: 5px;
            margin-bottom: 10px;
            .judge {
              line-height: 24px;
              padding: 8px 10px;
              &.split_line {
                border-bottom: 1px solid #ececec;
              }
              label {
                .title_text {
                  margin-left: 5px;
                }
              }
            }
          }
        }
      }
    }
  }
  .operate_box {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 5;
    display: flex;
    width: 100%;
    height: 50px;
    padding: 5px 5px;
    background-color: #fff;
    border-top: 1px solid #ebedf0;
    .operate_btn {
      flex: 1;
      height: 40px;
      line-height: 40px;
      background-color: #397ef5;
      margin-left: 5px;
      margin-right: 5px;
      text-align: center;
      color: #fff;
      font-size: 16px;
    }
  }
}
</style>